import Process1 from '../../assets/image/saasModern/process-1.svg';
import Process2 from '../../assets/image/saasModern/process-2.svg';
import Process3 from '../../assets/image/saasModern/process-3.svg';

import Service1 from '../../assets/image/saasModern/service-1.svg';
import Service2 from '../../assets/image/saasModern/service-2.svg';
import Service3 from '../../assets/image/saasModern/service-3.svg';
import Service4 from '../../assets/image/saasModern/service-4.svg';
import Service5 from '../../assets/image/saasModern/service-5.svg';

import Paquete1 from '../../assets/image/saasModern/paquete-1.svg';
import Paquete2 from '../../assets/image/saasModern/paquete-2.svg';
import Paquete3 from '../../assets/image/saasModern/paquete-3.svg';
import Paquete4 from '../../assets/image/saasModern/paquete-4.svg';
import Paquete5 from '../../assets/image/saasModern/paquete-5.svg';

import { ic_monetization_on } from 'react-icons-kit/md/ic_monetization_on';
import { ic_settings } from 'react-icons-kit/md/ic_settings';
import { pieChart } from 'react-icons-kit/icomoon/pieChart';
import { briefcase } from 'react-icons-kit/fa/briefcase';

import Screenshot1 from '../../assets/image/contpaqiContabilidad/screenshot1.png';
import Screenshot2 from '../../assets/image/contpaqiContabilidad/screenshot2.png';
import Screenshot3 from '../../assets/image/contpaqiContabilidad/screenshot3.png';
import Screenshot4 from '../../assets/image/contpaqiContabilidad/screenshot4.png';
import Screenshot21 from '../../assets/image/contpaqiNominas/screenshot1.png';
import Screenshot22 from '../../assets/image/contpaqiNominas/screenshot2.png';
import Screenshot23 from '../../assets/image/contpaqiNominas/screenshot3.png';
import Screenshot24 from '../../assets/image/contpaqiNominas/screenshot4.png';
import Screenshot31 from '../../assets/image/contpaqiBancos/screenshot1.png';
import Screenshot32 from '../../assets/image/contpaqiBancos/screenshot2.png';
import Screenshot33 from '../../assets/image/contpaqiBancos/screenshot3.png';
import Screenshot34 from '../../assets/image/contpaqiBancos/screenshot4.png';
import Screenshot41 from '../../assets/image/contpaqiXMLenLinea/screenshot1.png';
import Screenshot42 from '../../assets/image/contpaqiXMLenLinea/screenshot2.png';
import Screenshot43 from '../../assets/image/contpaqiXMLenLinea/screenshot3.png';
import Screenshot44 from '../../assets/image/contpaqiXMLenLinea/screenshot4.png';
import Screenshot51 from '../../assets/image/contpaqiFacturaElectronica/screenshot1.png';
import Screenshot52 from '../../assets/image/contpaqiFacturaElectronica/screenshot2.png';
import Screenshot53 from '../../assets/image/contpaqiFacturaElectronica/screenshot3.png';
import Screenshot54 from '../../assets/image/contpaqiFacturaElectronica/screenshot4.png';
import Screenshot61 from '../../assets/image/contpaqiCFDIenLinea/screenshot1.png';
import Screenshot62 from '../../assets/image/contpaqiCFDIenLinea/screenshot2.png';
import Screenshot63 from '../../assets/image/contpaqiCFDIenLinea/screenshot3.png';
import Screenshot64 from '../../assets/image/contpaqiCFDIenLinea/screenshot4.png';
import Screenshot71 from '../../assets/image/contpaqiComercial/screenshot1.png';
import Screenshot72 from '../../assets/image/contpaqiComercial/screenshot2.png';
import Screenshot73 from '../../assets/image/contpaqiComercial/screenshot3.png';
import Screenshot74 from '../../assets/image/contpaqiComercial/screenshot4.png';
import Screenshot81 from '../../assets/image/contpaqiProduccion/screenshot1.png';
import Screenshot82 from '../../assets/image/contpaqiProduccion/screenshot2.png';
import Screenshot83 from '../../assets/image/contpaqiProduccion/screenshot3.png';
import Screenshot84 from '../../assets/image/contpaqiProduccion/screenshot4.png';
import Screenshot91 from '../../assets/image/contpaqiPDV/screenshot1.png';
import Screenshot92 from '../../assets/image/contpaqiPDV/screenshot2.png';
import Screenshot93 from '../../assets/image/contpaqiPDV/screenshot3.png';
import Screenshot94 from '../../assets/image/contpaqiPDV/screenshot4.png';

import Screenshot105 from '../../assets/image/acronis/screenshot1.png';
import Screenshot106 from '../../assets/image/acronis/screenshot2.png';
import Screenshot107 from '../../assets/image/acronis/screenshot3.png';
import Screenshot108 from '../../assets/image/acronis/screenshot4.png';
import Screenshot109 from '../../assets/image/gigas/screenshot1.png';
import Screenshot110 from '../../assets/image/gigas/screenshot2.png';
import Screenshot111 from '../../assets/image/gigas/screenshot3.png';
import Screenshot112 from '../../assets/image/gigas/screenshot4.png';


import AuthorOne from '../../assets/image/saasModern/author-1.jpg';
import AuthorTwo from '../../assets/image/saasModern/author-2.jpg';
import AuthorThree from '../../assets/image/saasModern/author-3.jpg';

import solucionImage from '../../assets/image/saasModern/solucion-image.png';

import infoContpaqImage1 from '../../assets/image/saasModern/infocontpaq1-image.png';
import infoContpaqImage2 from '../../assets/image/saasModern/infocontpaq2-image.png';

import { socialTwitter } from 'react-icons-kit/ionicons/socialTwitter';
import { socialFacebook } from 'react-icons-kit/ionicons/socialFacebook';
import { socialInstagram } from 'react-icons-kit/ionicons/socialInstagram';
import { socialYoutube } from 'react-icons-kit/ionicons/socialYoutube';

import PortfolioImage1 from '../../assets/image/ContpaqProcesosContables/portfolio-1.jpg';
import PortfolioImage2 from '../../assets/image/ContpaqProcesosContables/portfolio-2.jpg';
import PortfolioImage3 from '../../assets/image/ContpaqProcesosContables/portfolio-3.jpg';
import PortfolioImage4 from '../../assets/image/ContpaqProcesosContables/portfolio-4.jpg';
import PortfolioImage5 from '../../assets/image/ContpaqProcesosContables/portfolio-5.jpg';
import PortfolioImage6 from '../../assets/image/ContpaqProcesosContables/portfolio-6.jpg';
import PortfolioImage7 from '../../assets/image/ContpaqProcesosContables/portfolio-7.jpg';
import PortfolioImage8 from '../../assets/image/ContpaqProcesosContables/portfolio-8.jpg';
import PortfolioImage9 from '../../assets/image/ContpaqProcesosContables/portfolio-9.jpg';

import BannerImage1 from '../../assets/image/contpaqiContabilidad/banner-image.png';
import BannerImage2 from '../../assets/image/contpaqiNominas/banner-image.png';
import BannerImage3 from '../../assets/image/contpaqiBancos/banner-image.png';
import BannerImage4 from '../../assets/image/contpaqiXMLenLinea/banner-image.png';
import BannerImage5 from '../../assets/image/contpaqiFacturaElectronica/banner-image.png';
import BannerImage6 from '../../assets/image/contpaqiCFDIenLinea/banner-image.png';
import BannerImage7 from '../../assets/image/contpaqiComercial/banner-image.png';
import BannerImage8 from '../../assets/image/contpaqiProduccion/banner-image.png';
import BannerImage9 from '../../assets/image/contpaqiPDV/banner-image.png';

import ProdImage1 from '../../assets/image/productos/prodimage1.jpg';
import ProdImage2 from '../../assets/image/productos/prodimage2.jpg';
import ProdImage3 from '../../assets/image/productos/prodimage3.jpg';

export const PRODUCTOS = [
  {
    id: 1,
    title: 'CONTPAQi',
    thumbnail_url: ProdImage1,
    date: 'Administración, Contable, Productividad',
    postLink: '/contpaqi',
  },
  {
    id: 2,
    title: 'Acronis Cloud Backup',
    thumbnail_url: ProdImage2,
    date: 'Respaldo de información ',
    postLink: '/acronis',
  },
  {
    id: 3,
    title: 'Gigas Cloud Datacenter',
    thumbnail_url: ProdImage3,
    date: 'Servidores en la nube',
    postLink: '/gigas',
  },
];


export const ABOUTUS = [
  {
    id: 1,
    title: 'Tiempo de respuesta record',
    icon: 'flaticon-next',
  },
  {
    id: 2,
    title: 'Atención personalizada a equipos.',
    icon: 'flaticon-next',
  },
  {
    id: 3,
    title: 'Uso de las Tecnologías de la Información.',
    icon: 'flaticon-next',
  },
  {
    id: 4,
    title: 'Asesoría orientada al cliente.',
    icon: 'flaticon-next',
  },
];

export const MENU_ITEMS = [
  {
    label: 'Distribuidor CONTPAQi',
    path: '/contpaqi',
    offset: '0',
  },
  {
    label: 'Nosotros',
    path: '/nosotros',
    offset: '0',
  },
  {
    label: 'Productos',
    path: '/productos',
    offset: '0',
  },
  {
    label: 'Soporte',
    path: '/soporte',
    offset: '0',
  },
];

export const SERVICE_ITEMS = [
  {
    icon: Service1,
    title: 'Financiera',
  },
  {
    icon: Service2,
    title: 'Contable',
  },
  {
    icon: Service3,
    title: 'Comercial',
  },
  {
    icon: Service4,
    title: 'Seguridad TI',
  },
  {
    icon: Service5,
    title: 'Operativa',
  },
];

export const PAQUETES_ITEMS = [
  {
    icon: Paquete1,
    title: '$1,790',
  },
  {
    icon: Paquete2,
    title: '$4,990',
  },
  {
    icon: Paquete3,
    title: '$8,990',
  },
  {
    icon: Paquete4,
    title: '$17,490',
  },
  {
    icon: Paquete5,
    title: '$29,990',
  },
];

export const PROCESS_ITEMS = [
  {
    image: Process1,
    title: 'Finanzas y Contabilidad',
    description:
      '¿La empresa no cuenta con un sistema integral y muchos procesos contables y actualizaciones se realizan de forma manual?',
  },
  {
    image: Process2,
    title: 'Informes y estadísticas',
    description:
      '¿En el momento de redactar un informe, son interminables las hojas de cálculo con información inconsistente?',
  },
  {
    image: Process3,
    title: 'Administración de la Nómina',
    description:
      'La carga administrativa se acumula al final de mes ¿Y la nómina es una carga tediosa que aveces conduce a errores?',
  },
];

export const SOLUCION_PIC = { image: solucionImage };


export const SOLUTION_ITEMS = [
  {
    id: 1,
    icon: 'flaticon-security',
    title: 'Confianza',
    description:
    'Nuestras soluciones contables y administrativas cuentan con casi un millón de usuarios.',
  },
  {
    id: 2,
    icon: 'flaticon-strategy',
    title: 'Profesionalidad',
    description:
    'Tenemos cobertura nacional y nuestras soluciones son líderes en facturación electrónica.',
  },
  {
    id: 3,
    icon: 'flaticon-money-bag',
    title: 'Economía',
    description:
    'Proveemos software empresarial que respalda los procesos de las empresas con conocimiento y tecnología.',
  },
  {
    id: 4,
    icon: 'flaticon-startup',
    title: 'Innovación',
    description:
    'Invertimos todo nuestro esfuerzo seleccionando las mejores soluciones empresariales para nuestros clientes.',
  },
];

export const INFOCONTPAQ_PIC1 = { image: infoContpaqImage1 };
export const INFOCONTPAQ_PIC2 = { image: infoContpaqImage2 };


export const MONTHLY_PRICING_TABLE = [
  {
    freePlan: true,
    name: 'CONTPAQi Contabilidad',
    description: 'Facilita la captura, registro y contabilización de tu información fiscal y financiera, a través del sistema favorito de los Contadores',
    price: '$4,190.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Analiza situación contable/fiscal',
      },
      {
        content: 'Tablero Fiscal información CFDI',
      },
      {
        content: 'Recibo Electrónico de Pagos REP',
      },
      {
        content: 'Administra Documentos Digitales',
      },
      {
        content: 'Exporta la información a Excel®',
      },
    ],
  },
  {
    name: 'CONTPAQi Nóminas',
    description: 'Cumple en tiempo y forma con todas las obligaciones de ley en materia de sueldos y salarios como CFDI 3.3, IMSS, Infonavit e impuestos',
    price: '$3,890.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Cumple obligaciones ISR e IMSS',
      },
      {
        content: 'Contabiliza CFDI sueldos/salarios',
      },
      {
        content: 'Asegura pago correcto de impuesto',
      },
      {
        content: 'Evita errores en tu Cálculo Anual',
      },
      {
        content: 'Analiza cuotas del IMSS a pagar',
      },
    ],
  },
  {
    name: 'CONTPAQi Bancos',
    description: 'Cuida y haz crecer tu flujo de efectivo, a través de este sistema que te ayuda a tener visión del dinero que ingresa y egresa de tu empresa',
    price: '$3,690.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Administra el flujo de efectivo',
      },
      {
        content: 'Programa/Identifica pagos',
      },
      {
        content: 'Controla ingresos y gastos',
      },
      {
        content: 'Organiza por proyecto, área u obra',
      },
      {
        content: 'Cobranza y conciliación bancaria',
      },
    ],
  },
  {
    freePlan: true,
    name: 'CONTPAQi XML En Línea +',
    description: 'Ayuda a tus clientes a cumplir con sus obligaciones fiscales, recuperando todos los XML de las facturas emitidas y recibidas ',
    price: '$1,490.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Recupera XML facturas en el SAT',
      },
      {
        content: 'Descarga hasta 500 XML/búsqueda ',
      },
      {
        content: 'Identifica comprobantes cancelados',
      },
      {
        content: 'Gestiona/procesa XMLs (en ADD)',
      },
      {
        content: 'Valida XML y detecta duplicados',
      },
    ],
  },
];

export const YEARLY_PRICING_TABLE = [
  {
    freePlan: true,
    name: 'CONTPAQi Comercial Start, Pro, Premium',
    description: 'Integra los procesos de compras, ventas, facturación e inventarios con 3 versiones que mejor se adaptan a las necesidades de tu empresa',
    price: '$1,990.00*',
    priceLabel: '*desde / Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Integra procesos de ventas, facturación, compras, inventarios, cobranza y cuentas por pagar',
      },
      {
        content: 'Folios ilimitados sin costo',
      },
      {
        content: 'Cumple con el Recibo Electrónico de Pagos (REP) y el nuevo esquema de Cancelación CFDI',
      },
      {
        content: 'Reportes de inventarios y costos ',
      },
    ],
  },
  {
    name: 'CONTPAQi Factura electrónica',
    description: 'Agiliza tu proceso de facturación y el control de tus cuentas por cobrar para hacer más productivo tu negocio o empresa',
    price: '$1,990.00*',
    priceLabel: '*desde / Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Emite facturas, notas de crédito, recibos de honorarios, arrendamiento entre otros',
      },
      {
        content: 'Folios ilimitados sin costo',
      },
      {
        content: 'Cumple con REP y esquema Cancelación CFDI',
      },
      {
        content: 'Controla las cuentas por cobrar mediante catálogos y reportes de edo. cuenta',
      },
      {
        content: 'Addendas y complementos fiscales',
      },
    ],
  },
  {
    name: 'CONTPAQi Punto de Venta',
    description: 'Cuida tu caja y agiliza las operaciones de tu punto de venta. Se adapta fácilmente a empresas de comercio con venta al detalle',
    price: '$2,990.00*',
    priceLabel: '*desde / Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Folios ilimitados sin costo adicional para emisión/cancelación CFDI',
      },
      {
        content: 'Reporta a detalle cortes de caja',
      },
      {
        content: 'Autorización de pagos con tarjeta de crédito o débito',
      },
      {
        content: 'Inventarios a detalle por productos, unidades de medida, peso, series, lotes, pedimentos, entre otros',
      },
    ],
  },
];

export const FAQ_DATA = [
  {
    expend: true,
    title: '¿Cómo contactar con Atención al Cliente?',
    description:
      'Nuestro equipo de atención al cliente está disponible 5 días de la semana, de 9am a 5pm y ofrecemos 3 formas de contacto. Correo electrónico, chat y Whatsapp. Intentamos responder rápidamente, por lo que la espera no será demasiada para recibir una respuesta nuestra.',
  },
  {
    title: 'Instalación de las aplicaciones, ¿cómo actualizar o instalar los sistema CONTPAQi?',
      description: 

      'Con nuestras Pólizas de Servicio, obtienes la manera más fácil y cómoda de asegurar el funcionamiento óptimo de tu software así como de obtener el respaldo de expertos profesionales, con asesoría y soporte para tu sistema con un amplio horario.',
  },
  {
    title: '¿Cuanto tiempo tardará un ejecutivo en resolver dudas de mi sistema CONTPAQi?',
    description:
      'La Polizas Remota, está diseñada, para trabajar de manera cómoda, segura y efectiva a través de un escritorio remoto, donde un ejecutivo le atenderá y brindará el soporte que requiera en el momento.',
  },
  {
    title: '¿Cómo podemos sacar el máximo provecho a sus productos y servicios?',
    description:
      'Contamos con cursos para todos los sistemas CONTPAQi. Dichos cursos pueden ser impartidos en nuestras instalaciones o bien en la oficina del cliente. El tiempo de duración, fechas de impartición, sede y costo se definen de acuerdo a las necesidades cada cliente.',
  },
];

export const FOOTER_WIDGET = [
  {
    title: 'Nosotros',
    menuItems: [
      {
        url: '/nosotros',
        text: 'Sobre nosotros',
      },
      {
        url: '/avisodeprivacidad.pdf',
        text: 'Aviso de privacidad',
      },
    ],
  },
  {
    title: 'Servicios',
    menuItems: [
      {
        url: '/servicios',
        text: 'Contrato anual de Soporte',
      },
      {
        url: '/servicios',
        text: 'Pólizas Remotas ',
      },
      {
        url: '/servicios',
        text: 'Pólizas Presenciales',
      },
    ],
  },
  {
    title: 'CONTPAQi®',
    menuItems: [
      {
        url: '/contpaqi',
        text: 'Productos Contables',
      },
      {
        url: '/contpaqi',
        text: 'Productos Comerciales',
      },
    ],
  },
  {
    title: 'Seguridad TI',
    menuItems: [
      {
        url: '/productos',
        text: 'Acronis Cloud Backup',
      },
      {
        url: '/productos',
        text: 'Gigas Cloud Datacenter',
      },
      {
        url: '/productos',
        text: 'Adaware Conectores',
      },
    ],
  },
];


export const SCREENSHOTS = [
  {
    icon: ic_monetization_on,
    title: 'Tablero Fiscal',
    image: Screenshot1,
  },
  {
    icon: ic_settings,
    title: 'Pólizas',
    image: Screenshot2,
  },
  {
    icon: pieChart,
    title: 'Nuevo ADD',
    image: Screenshot3,
  },
  {
    icon: briefcase,
    title: 'REP > Pólizas de pago',
    image: Screenshot4,
  },
];


export const SCREENSHOTS2 = [
  {
    icon: ic_monetization_on,
    title: 'Emite CFDI',
    image: Screenshot21,
  },
  {
    icon: ic_settings,
    title: 'Envía CFDI',
    image: Screenshot22,
  },
  {
    icon: pieChart,
    title: 'Conciliación ISR',
    image: Screenshot23,
  },
  {
    icon: briefcase,
    title: 'Contabilidad',
    image: Screenshot24,
  },
];


export const SCREENSHOTS3 = [
  {
    icon: ic_monetization_on,
    title: 'Catálogos',
    image: Screenshot31,
  },
  {
    icon: ic_settings,
    title: 'Conciliaciones',
    image: Screenshot32,
  },
  {
    icon: pieChart,
    title: 'Retenciones',
    image: Screenshot33,
  },
  {
    icon: briefcase,
    title: 'Categorización',
    image: Screenshot34,
  },
];


export const SCREENSHOTS4 = [
  {
    icon: ic_monetization_on,
    title: 'Comprobantes',
    image: Screenshot41,
  },
  {
    icon: ic_settings,
    title: 'Conexión SAT',
    image: Screenshot42,
  },
  {
    icon: ic_settings,
    title: 'Visor',
    image: Screenshot43,
  },
  {
    icon: briefcase,
    title: 'ADD',
    image: Screenshot44,
  },
];


export const SCREENSHOTS5 = [
  {
    icon: ic_monetization_on,
    title: 'Addendas',
    image: Screenshot51,
  },
  {
    icon: ic_settings,
    title: 'Multi RFC',
    image: Screenshot52,
  },
  {
    icon: ic_settings,
    title: 'Catálogo',
    image: Screenshot53,
  },
  {
    icon: briefcase,
    title: 'Cuentas por cobrar',
    image: Screenshot54,
  },
];


export const SCREENSHOTS6 = [
  {
    icon: ic_monetization_on,
    title: 'Login En Línea',
    image: Screenshot61,
  },
  {
    icon: ic_settings,
    title: 'Pagos',
    image: Screenshot62,
  },
  {
    icon: ic_settings,
    title: 'Facturación',
    image: Screenshot63,
  },
  {
    icon: briefcase,
    title: 'Catálogos',
    image: Screenshot64,
  },
];


export const SCREENSHOTS7 = [
  {
    icon: ic_monetization_on,
    title: 'Compras y Gastos',
    image: Screenshot71,
  },
  {
    icon: ic_settings,
    title: 'Inventarios',
    image: Screenshot72,
  },
  {
    icon: ic_settings,
    title: 'Ventas',
    image: Screenshot73,
  },
  {
    icon: briefcase,
    title: 'Pólizas',
    image: Screenshot74,
  },
];


export const SCREENSHOTS8 = [
  {
    icon: ic_settings,
    title: 'Configuración',
    image: Screenshot81,
  },
  {
    icon: ic_settings,
    title: 'Catálogos',
    image: Screenshot82,
  },
  {
    icon: ic_monetization_on,
    title: 'Operaciones',
    image: Screenshot83,
  },
  {
    icon: briefcase,
    title: 'Requerimientos',
    image: Screenshot84,
  },
];


export const SCREENSHOTS9 = [
  {
    icon: ic_monetization_on,
    title: 'Inventarios',
    image: Screenshot91,
  },
  {
    icon: ic_settings,
    title: 'Clasificación',
    image: Screenshot92,
  },
  {
    icon: ic_settings,
    title: 'Reportes',
    image: Screenshot93,
  },
  {
    icon: briefcase,
    title: 'Productos',
    image: Screenshot94,
  },
];



export const SCREENSHOTSACRONIS = [
  {
    icon: ic_settings,
    title: 'Dashboars',
    image: Screenshot105,
  },
  {
    icon: ic_settings,
    title: 'Respaldos',
    image: Screenshot106,
  },
  {
    icon: ic_monetization_on,
    title: 'Servicios',
    image: Screenshot107,
  },
  {
    icon: briefcase,
    title: 'Reportes',
    image: Screenshot108,
  },
];

export const SCREENSHOTSGIGAS = [
  {
    icon: ic_settings,
    title: 'Panel de control',
    image: Screenshot109,
  },
  {
    icon: ic_settings,
    title: 'Backups',
    image: Screenshot110,
  },
  {
    icon: ic_settings,
    title: 'Balanceadores',
    image: Screenshot111,
  },
  {
    icon: ic_settings,
    title: 'Firewall',
    image: Screenshot112,
  },
];


export const TESTIMONIALS = [
  {
    title: 'Un servicio de consultoría profesional',
    review:
      'Estoy sorprendido con sus servicios de consultoría. Todo el proceso de identificación de necesidades a nuestra organización se realizo de forma muy profesional. Sus propuestas siempre cumplen nuestros requerimientos, sin mencionar que son muy atentos. ¿Recomiendo ADAWARE? Por supuesto.',
    name: 'Edgar Barrios',
    designation: 'Director Insight Media',
    avatar: `${AuthorOne}`,
  },
  {
    title: 'Relación duradera y servicios profesionales',
    review:
      'El atractivo en ADAWARE es que siempre han entendido nuestras necesidades de procesos y software, y con su ayuda hemos implementado desde hace más de 10 años los procesos necesarios para el crecimiento de nuestra empresa. El servicio es de primera.',
    name: 'Carlos Torreblanca',
    designation: 'Amadeus Servicios',
    avatar: `${AuthorTwo}`,
  },
  {
    title: 'Entienden nuestras necesidades',
    review:
      'ADAWARE es una consultoria con amplio profesionalismo sobre una amplia variedad de productos y servicios. Por la relación que hemos sostenido y la pronta respuesta a eventualidades, sigo renovando sus servicios de consultoría y los recomiendo a cualquier empresa.',
    name: 'Cristina Salvatorre',
    designation: 'Gerente Plaza Lomas',
    avatar: `${AuthorThree}`,
  },
];

export const SOCIAL_PROFILES = [
  {
    icon: socialTwitter,
    url: 'https://twitter.com/adaware_master',
  },
  {
    icon: socialFacebook,
    url: 'https://www.facebook.com/Adawaremaster/',
  },
  {
    icon: socialInstagram,
    url: 'https://www.instagram.com/adaware/',
  },
  {
    icon: socialYoutube,
    url: 'https://www.youtube.com/channel/UCV9oHeWqpdZYfExparRLmKQ',
  },
];




export const PORTFOLIO_SHOWCASE = [
  {
    title: 'Contabilidad',
    portfolioItem: [
      {
        title: 'CONTPAQi® Contabilidad',
        description:
          "Facilita la captura, registro y contabilización de tu información fiscal y financiera, a través del sistema favorito de los Contadores.",
        image: PortfolioImage1,
        link: '/contpaqi-contabilidad',
        featuredIn: '2019-Julio-03',
        featuredLink: 'http://adaware.com.mx/licencias.php',
        view: '11.6.0',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage1,
        Youtube: 'https://www.youtube.com/embed/wgBEeE9sKSQ',
        subtitulo: 'CONTPAQi® Contabilidad, el sistema preferido de los contadores.',
        
        buildWith: [
          {
            content: 'Contable',
          },
          {
            content: 'Fiscal',
          },
          {
            content: 'Financiero',
          },
        ],
      },
    ],
  },
  {
    title: 'Nómina',
    portfolioItem: [
      {
        title: 'CONTPAQi® Nómina',
        description:
          "Cumple en tiempo y forma con todas las obligaciones de ley en materia de sueldos y salarios como CFDI 3.3, IMSS, Infonavit e impuestos.",
        image: PortfolioImage2,
        link: '/contpaqi-nominas',
        featuredIn: '2019-Junio-26',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '11.4.1',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage2,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® Nómina, el sistema para la administración de la nómina.',
        buildWith: [
          {
            content: 'CFDI 3.3',
          },
          {
            content: 'ISR e IMSS',
          },
          {
            content: 'Impuestos',
          },
        ],
      },
    ],
  },
  {
    title: 'Bancos',
    portfolioItem: [
      {
        title: 'CONTPAQi® Bancos',
        description:
          "Cuida y haz crecer tu flujo de efectivo, a través de este sistema que te ayuda a tener visión del dinero que ingresa y egresa de tu empresa.",
        image: PortfolioImage3,
        link: '/contpaqi-bancos',
        featuredIn: '2019-Julio-03',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '11.6.0',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage3,
        Youtube: 'https://www.youtube.com/embed/_RhSx-Lx7Fc',
        subtitulo: 'CONTPAQi® Bancos, el sistema que facilita la administración de tu flujo de efectivo.',
        buildWith: [
          {
            content: 'Cobranza',
          },
          {
            content: 'Conciliación',
          },
          {
            content: 'Ingresos / Gastos',
          },
        ],
      },
    ],
  },
  {
    title: 'XML En Línea+',
    portfolioItem: [
      {
        title: 'CONTPAQi® XML En Línea+',
        description:
          "Ayuda a tus clientes a cumplir con sus obligaciones fiscales, recuperando XML de las facturas conectándote al SAT.",
        image: PortfolioImage4,
        link: '/contpaqi-xml-en-linea',
        featuredIn: '2018-Diciembre-07',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '2.0.7',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage4,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® XML En Línea+, el sistema que te facilita la búsqueda y descarga de tus CFDI',
        buildWith: [
          {
            content: 'Cumplimiento',
          },
          {
            content: 'Gestión',
          },
          {
            content: 'Facturación',
          },
        ],
      },
    ],
  },

];



export const PORTFOLIO_COMERCIAL = [
  {
    title: 'Factura Electrónica',
    portfolioItem: [
      {
        title: 'CONTPAQi® Factura Electrónica',
        description:
          "Automatiza y haz mas eficiente tu proceso de facturacion en el sistema que mejor se adapta a tu administración comercial.",
        image: PortfolioImage5,
        link: '/contpaqi-factura-electronica',
        featuredIn: '2019-Mayo-15',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '6.3.0',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage5,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® Factura Electrónica sistema que facilita la emisión y recepción de tu CFDI',
        buildWith: [
          {
            content: 'Folios',
          },
          {
            content: 'Productividad',
          },
          {
            content: 'CFDI',
          },
        ],
      },
    ],
  },
  {
    title: 'CFDI en línea+',
    portfolioItem: [
      {
        title: 'CONTPAQi® CFDI Facturación en línea+',
        description:
          "Facilita la emisión y timbrado de tus CFDI por internet y cumple a tiempo con las disposiciones fiscales.",
        image: PortfolioImage6,
        link: '/contpaqi-cfdi-facturacion-en-linea',
        featuredIn: '',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '3.4.4',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage6,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® CFDI Facturación en línea+ Emite tus CFDI de manera ilimitada',
        buildWith: [
          {
            content: 'CFDI 3.3',
          },
          {
            content: 'Facturas',
          },
          {
            content: 'Flexible',
          },
        ],
      },
    ],
  },
  {
    title: 'Comercial',
    portfolioItem: [
      {
        title: 'CONTPAQi® Comercial',
        description:
          "Integra procesos de compras, ventas, facturación e inventarios con la versión que mejor se adapta a las necesidades de tu empresa.",
        image: PortfolioImage7,
        link: '/contpaqi-comercial',
        featuredIn: '2019-Abril-26',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '4.5.1',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage7,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® Comercial administra tu ciclo comercial de compra/venta con tu proceso contable',
        buildWith: [
          {
            content: 'Contable',
          },
          {
            content: 'Cobranza',
          },
          {
            content: 'Ventas',
          },
        ],
      },
    ],
  },
  {
    title: 'Producción',
    portfolioItem: [
      {
        title: 'CONTPAQi® Producción',
        description:
          "Controla y administra los recursos/procesos de producción y fabricación de tu empresa e impulsa la productividad de tu negocio.",
        image: PortfolioImage8,
        link: '/contpaqi-produccion',
        featuredIn: '2019-Mayo-23',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '3.1.0',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage8,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® Producción buenas prácticas de manufactura para controlar tu producción',
        buildWith: [
          {
            content: 'Administra',
          },
          {
            content: 'Inventarios',
          },
          {
            content: 'Rentabilidad',
          },
        ],
      },
    ],
  },
  {
    title: 'Punto de Venta',
    portfolioItem: [
      {
        title: 'CONTPAQi® Punto de Venta',
        description:
          "Cuida tu caja y agiliza operaciones de tu punto de venta, inventarios y facturación. ¡Ideal para empresas de comercio al detalle!",
        image: PortfolioImage9,
        link: '/contpaqi-punto-de-venta',
        featuredIn: '2018-Febrero-28',
        featuredLink: 'http://adaware.com.mx/ingresar.php',
        view: '4.2.0',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage9,
        Youtube: 'https://www.youtube.com/embed/82Avo4E7QGQ',
        subtitulo: 'CONTPAQi® Punto de Venta agiliza las operaciones en tus inventarios, caja y facturación.',
        buildWith: [
          {
            content: 'CFDI',
          },
          {
            content: 'Facturación',
          },
          {
            content: 'Inventarios',
          },
        ],
      },
    ],
  },
];

export const PORTFOLIO_OTROS = [
  {
    title: 'Acronis',
    portfolioItem: [
      {
        title: 'Acronis',
        description: "",
        image: PortfolioImage2,
        link: '/acronis',
        featuredIn: '',
        featuredLink: '',
        view: '',
        love: '',
        trialdesc: '',
        BannerImage: BannerImage2,
        Youtube: '',
        subtitulo: 'La copia de seguridad más fiable y fácil para empresas de cualquier tamaño.',
        buildWith: [
          {
            content: 'CFDI 3.3',
          },
          {
            content: 'ISR e IMSS',
          },
          {
            content: 'Impuestos',
          },
        ],
      },
    ],
  },
  {
    title: 'Gigas',
    portfolioItem: [
      {
        title: 'Gigas',
        description: "",
        image: PortfolioImage1,
        link: '/gigas',
        featuredIn: '',
        featuredLink: '',
        view: '',
        love: '',
        trialdesc: "Descarga gratuitamente uno o más sistemas CONTPAQi por un período de 30 días y conoce los beneficios que dan a tu empresa.",
        BannerImage: BannerImage1,
        Youtube: 'https://www.youtube.com/embed/wgBEeE9sKSQ',
        subtitulo: 'GIGAS La forma más fácil de desplegar infraestructura en la nube.',
        
        buildWith: [
          {
            content: 'Contable',
          },
          {
            content: 'Fiscal',
          },
          {
            content: 'Financiero',
          },
        ],
      },
    ],
  },
];

export const SOPORTE_TABLE = [
  {
    freePlan: true,
    name: 'CONTPAQi Contabilidad',
    description: 'Facilita la captura, registro y contabilización de tu información fiscal y financiera, a través del sistema favorito de los Contadores',
    price: '$4,190.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Analiza situación contable/fiscal',
      },
      {
        content: 'Tablero Fiscal información CFDI',
      },
      {
        content: 'Recibo Electrónico de Pagos REP',
      },
      {
        content: 'Administra Documentos Digitales',
      },
      {
        content: 'Exporta la información a Excel®',
      },
    ],
  },
  {
    name: 'CONTPAQi Nóminas',
    description: 'Cumple en tiempo y forma con todas las obligaciones de ley en materia de sueldos y salarios como CFDI 3.3, IMSS, Infonavit e impuestos',
    price: '$3,890.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Cumple obligaciones ISR e IMSS',
      },
      {
        content: 'Contabiliza CFDI sueldos/salarios',
      },
      {
        content: 'Asegura pago correcto de impuesto',
      },
      {
        content: 'Evita errores en tu Cálculo Anual',
      },
      {
        content: 'Analiza cuotas del IMSS a pagar',
      },
    ],
  },
  {
    name: 'CONTPAQi Bancos',
    description: 'Cuida y haz crecer tu flujo de efectivo, a través de este sistema que te ayuda a tener visión del dinero que ingresa y egresa de tu empresa',
    price: '$3,690.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Administra el flujo de efectivo',
      },
      {
        content: 'Programa/Identifica pagos',
      },
      {
        content: 'Controla ingresos y gastos',
      },
      {
        content: 'Organiza por proyecto, área u obra',
      },
      {
        content: 'Cobranza y conciliación bancaria',
      },
    ],
  },
  {
    freePlan: true,
    name: 'CONTPAQi XML En Línea +',
    description: 'Ayuda a tus clientes a cumplir con sus obligaciones fiscales, recuperando todos los XML de las facturas emitidas y recibidas ',
    price: '$1,490.00*',
    priceLabel: 'Pesos Mexicanos + IVA',
    buttonLabel: 'PROBAR 1 MES GRATIS',
    url: '#',
    listItems: [
      {
        content: 'Recupera XML facturas en el SAT',
      },
      {
        content: 'Descarga hasta 500 XML/búsqueda ',
      },
      {
        content: 'Identifica comprobantes cancelados',
      },
      {
        content: 'Gestiona/procesa XMLs (en ADD)',
      },
      {
        content: 'Valida XML y detecta duplicados',
      },
    ],
  },
];

